<template>
    <div
        class="common-head"
        :class="{ fixed: fixed, 'border-bottom': border }"
        :style="{ zIndex: zIndex }"
    >
        <div class="head-left" v-if="back" @click="gotoBack"></div>
        <span>{{ title }}</span>
        <div class="head-right">
            <slot name="right"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "HeadBar",
    props: {
        fixed: {
            type: Boolean,
            default: false,
        },
        back: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "标题",
        },
        border: {
            type: Boolean,
            default: false,
        },
        zIndex: {
            default: 10,
        },
    },
    methods: {
        gotoBack() {
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="less" scoped>
.common-head {
    position: relative;
    height: 90px;
    background-color: #fff;
    font-size: 34px;
    line-height: 90px;
    text-align: center;
    color: #333333;
    &.border-bottom {
        border: 1px solid #f2f2f2;
    }
    &.fixed {
        position: fixed;
        z-index: 10;
        width: 750px;
        top: 0px;
        left: 50%;
        margin-left: -375px;
    }
    .head-left {
        position: absolute;
        z-index: 11;
        top: 0;
        left: 0;
        width: 30%;
        height: 90px;
        background-image: url("../public/images/head/head-back-icon.png");
        background-size: 48px;
        background-position: 30px 20px;
        background-repeat: no-repeat;
    }
    .head-right {
        position: absolute;
        z-index: 11;
        top: 0;
        right: 0;
        width: 50%;
        height: 90px;
    }
}
</style>
